<template>
  <div class="animated fadeIn">
      <div class="page-header d-flex">
        <h4 class="page-title">
          <i class="fas fa-table"></i>
          WSFinder Detect List
        </h4>
        <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
            <a href="#">
              <i class="fas fa-home text-muted"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a class="font_15 font-weight-bold" href="#">Detect</a>
          </li>
        </ul>
      </div>
      <!--//-------------------------------------------------------------------------검색조건-->
      <!-- detail_search -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="opt_date">Detected_at</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-group>
              <b-button class="md-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1W</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1M</b-button>
              <b-form inline class="mt-2">
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
            <label class="col-form-label" for="ph_search_opt_type">Group Name</label>
          </b-col>
          <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
            <b-form-group>
              <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
            </b-form-group>
          </b-col>
          <b-col v-if="!group_name" class="col-xl-4 col-md-12 align-self-center">
            <b-form-group>
              <b-button :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">Select Group</b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
            <label class="col-form-label" for="opt_mod">Isolation</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-group>
              <select class="form-control" v-model="so.opt['is_backup']" @change="refresh">
                <option disabled value="">Please select Mode</option>
                <option value='false'>Off</option>
                <option value='true'>On</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
            <label class="col-form-label" for="opt_os_type">OS</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-group>
              <select class="form-control" v-model="so.opt['agent.os_type']" @change="refresh">
                <option disabled value="">select Enable or Disable</option>
                <option value="windows">Windows</option>
                <option value="linux">Linux</option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
            <label class="col-form-label" for="opt_ip_addr">IP Address</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 align-self-center">
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_ip_addr" v-model="so.opt['agent.ip_addr']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="opt_host">Host</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 align-self-center">
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_host" v-model="so.opt['agent.host']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="col-xl-2 col-md-12 d=flex align-self">
            <label class="col-form-label" for="opt_name">Name</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 align-self">
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['agent.name']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self">
            <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 align-self">  
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">Match all</b-form-radio>
                <b-form-radio value="or">Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="float-right mt-3">
          <b-form-group>
            <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
            <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
            <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
          </b-form-group>
        </b-row>
      </b-card>
      <!-- detail_search -->
      <div class="d-flex flex-wrap align-items-center">
        <b-col sm="2">
          <span class="badge badge_border_primary mb-2">TOTAL : <span style="padding-left: 3.2rem;"></span>{{ (summaryData.total ? summaryData.total : 0).toString().padStart(10, nbsp) | number }}</span>
          <br>
          <span class="badge badge_border_info mb-2">Isolation : <span style="padding-left: 2.3rem;"></span>{{ (summaryData.enable ? summaryData.enable : 0).toString().padStart(10, nbsp) | number }}</span>
          <br>
          <span class="badge badge_border_warning mb-2">Not Isolation : <span style="padding-left: 0.5rem"></span>{{ (summaryData.disable ? summaryData.disable : 0).toString().padStart(10, nbsp) | number }}</span>
        </b-col>

        
        <b-col class="md-10 d-flex flex-wrap align-items-center">
          <div class="mr-auto mb7"></div>
          <div class="mb7 form-inline">
            <label class="col-form-label mr-2" for="sel3">Search Range</label>
            <div class="input-group">
              <date-picker @change="refresh" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </div>
            <span class="mx-2">~</span>
            <div class="input-group">
              <date-picker @change="refresh" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </div>
          </div>
          <br>
          <b-input-group size="sm">
            <div class="mr-auto mb7"></div>
            <div class="mt-2">
              <b-checkbox @change="refresh" class="ml-3 mt-2" v-model="hide_del">Hide deleted</b-checkbox>
            </div>
            <div class="mr-2 mb7 mt-2">
              <button class="btn btn-icon mr-1" @click="refresh()">
                <i class="fas fa-sync-alt"></i>
              </button>
              <button class="btn btn-icon mr-1" @click="reset()">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
                <option disabled value="">Search</option>
                <option value="group.groupname">Group</option>
                <option value="path">Path</option>
                <option value="agent.ip_addr">IP</option>
                <option value="agent.host">Host</option>
              </select>
            </div>
            <div class="mr-2 mb7">
              <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            </div>
            <div class="mb7">
              <button class="btn btn-icon1 mr-1" @click="refresh()">
                <i class="fas fa-search"></i>
              </button>
              <!-- <button class="btn btn-icon2" @click="search_opt">
                <i class="fas fa-search-plus"></i>
              </button> -->
            </div>
          </b-input-group>
        </b-col>
      </div>
      <!--//-------------------------------------------------------------------------검색조건-->
      <!--//-------------------------------------------------------------------------리스트출력-->
      <div class="reg_card">
        <div class="reg_card_body">
          <div class="table-responsive">
            <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="detail" style="cursor:pointer;">
              <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
              <template slot="group" slot-scope="row">
                <del v-if="row.item.is_del">{{row.item.group ? row.item.group.groupname : '-'}}</del>
                <span v-else>{{row.item.group ? row.item.group.groupname : '-'}}</span>
              </template>
              <template slot="agent" slot-scope="row">
                <span v-if="row.item.agent">{{row.item.agent.name}}({{row.item.agent.host}}@{{row.item.agent.ip_addr}})</span>
                <span v-else>No Agent(deleted or removed from db)</span>
              </template>
              <template slot="path" slot-scope="row">{{row.item.path | truncate(100)}}</template>
              <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            </b-table>
          </div> 
        </div>
      </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"/>
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>

    <!-- 시작 및 마지막 날짜 유무 확인 모달 -->
    <b-modal title="Search Range Setting" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only>
      Please specify start and end dates.
    </b-modal>

     <!-- 기간 설정 범위제한 모달-->
     <b-modal title="Search Range Setting" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-info" ok-only>
      WSFinder Detect List can be viewed in units of up to 1 year.
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>